// @flow
import React from 'react';
import type { Categories } from 'store/modules/partners';
import PartnerLikeButton from 'components/partner/PartnerLikeButton';
import { fromNow } from 'lib/common';
import PartnerActionButtons from '../PartnerActionButtons';
import './PartnerHead.scss';
import PartnerMobileShare from '../PartnerMobileShare/PartnerMobileShare';

type Props = {
  id: string,
  title: string,
  categories: Categories,
  user: {
    username: string,
    id: string,
    thumbnail: ?string,
    short_bio: ?string,
  },
  likes: number,
  liked: boolean,
  ownPartner: boolean,
  onToggleLike: () => void,
  onAskRemove: () => void,
  date: string,
  logged: boolean,
  url: string,
  isPrivate: boolean,
  informCopy: () => void,
};

const PartnerHead = ({
  id,
  title,
  date,
  categories,
  user,
  likes,
  liked,
  ownPartner,
  onToggleLike,
  onAskRemove,
  logged,
  isPrivate,
  url,
  informCopy,
}: Props) => {
  return (
    <div className="PartnerHead">
      <h1>{title}</h1>
      <div className="date-and-likes">
        <div className="date">{fromNow(date)}</div>
        <div className="placeholder" />
        <PartnerMobileShare
          url={url}
          title={title}
          username={user.username}
          informCopy={informCopy}
        />
        <PartnerLikeButton onClick={onToggleLike} liked={liked} likes={likes} disabled={!logged} />
      </div>
      <div className="separator" />
      {ownPartner && <PartnerActionButtons id={id} onAskRemove={onAskRemove} />}
    </div>
  );
};

PartnerHead.Placeholder = () => (
  <div className="PartnerHead placeholder">
    <div className="gray-block _title" />
    <div className="date-and-likes">
      <div className="date">
        <div className="gray-block _date" />
      </div>
      <div className="placeholder" />
    </div>
    <div className="separator" />
  </div>
);
export default PartnerHead;



// WEBPACK FOOTER //
// ./src/components/partner/PartnerHead/PartnerHead.js